import { emit, events, serviceQueries, query } from '@estee/elc-service-bus';
import { UNAUTHORIZED_MESSAGE_401, UNAUTHORIZED_MESSAGE_403 } from './StoresApiSdk';

export class ErrorHandler {
    public onRequestError = async (err: { message: string }) => {
        if (err.message === UNAUTHORIZED_MESSAGE_401 || err.message === UNAUTHORIZED_MESSAGE_403) {
            emit(events.UNAUTHORIZED_REQUEST);
            await query(serviceQueries.GET_GUEST_AUTH_TOKEN);
        } else {
            throw err;
        }
    };

    /* eslint-disable @typescript-eslint/no-explicit-any */
    public tryRequest = async (receivedQuery: () => Promise<any>) => {
        try {
            return await receivedQuery();
        } catch (e) {
            await this.onRequestError(e);
        }
    };
}
